module.exports = __webpack_public_path__ + "img/thumbnail10.b5a79adc.jpg";